import gql from 'graphql-tag'

export const DELETE_WATCHER = gql`
  mutation delete_watcher($input: Id) {
    delete_watcher(input: $input)
      @rest(type: "Watcher", path: "/delete-watcher", bodyKey: "input", method: "POST")
  }
`
